/* BarvoDeka – produktová stránka: galerie, balíčky (náhrada Kachingu), přidání do košíku */
(function () {
  'use strict';
  var T = window.BDT;
  if (!T) return;
  var $ = T.$, $$ = T.$$, formatMoney = T.formatMoney;
  var BD = window.BD || {};

  function initProduct(section) {
    var jsonEl = $('[data-product-json]', section.parentNode) || $('[data-product-json]');
    var data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [] };
    var form = $('[data-product-form]', section);
    if (!form || form.dataset.ready) return;
    form.dataset.ready = '1';
    var idInput = $('[data-variant-input]', form);
    var qtyInput = $('[data-qty-input]', form);
    var atc = $('[data-atc]', form);
    var atcLabel = $('[data-atc-label]', form);
    var slides = $('[data-gallery-slides]', section);
    var thumbs = $$('[data-thumb-index]', section);

    function variantById(id) {
      id = parseInt(id, 10);
      for (var i = 0; i < data.variants.length; i++) if (data.variants[i].id === id) return data.variants[i];
      return null;
    }
    function currentVariant() { return variantById(idInput.value) || data.variants[0]; }
    function checkedTier() { return $('[data-tier-radio]:checked', form); }
    function currentQty() { var r = checkedTier(); return r ? parseInt(r.value, 10) || 1 : 1; }

    /* Galerie – posun prstem (scroll-snap), klik na náhled, malé šipky u náhledů */
    var prev = $('[data-gallery-prev]', section), next = $('[data-gallery-next]', section);
    function goTo(index, smooth) {
      if (!slides) return;
      var n = slides.children.length;
      index = Math.max(0, Math.min(n - 1, index));
      slides.scrollTo({ left: slides.clientWidth * index, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function currentIndex() { return slides ? Math.round(slides.scrollLeft / (slides.clientWidth || 1)) : 0; }
    var lastIdx = -1;
    function updateNav(smooth) {
      if (!slides) return;
      var i = currentIndex(), n = slides.children.length;
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= n - 1;
      if (i === lastIdx) return;
      lastIdx = i;
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
      var th = thumbs[i];
      if (th) {
        // náhledy posunout jen tolik, aby byl aktivní celý vidět (žádné useknuté kraje)
        var strip = th.parentNode, x = th.offsetLeft - strip.offsetLeft - 1, sl = strip.scrollLeft, to = sl;
        if (x < sl) to = x; else if (x + th.offsetWidth + 2 > sl + strip.clientWidth) to = x + th.offsetWidth + 2 - strip.clientWidth;
        if (to !== sl) strip.scrollTo({ left: to, behavior: smooth ? 'smooth' : 'auto' });
      }
    }
    if (slides) slides.addEventListener('scroll', function () { updateNav(true); }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb-index'), 10)); }); });
    if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });
    function showMedia(mediaId, smooth) {
      if (!slides || !mediaId) return;
      var kids = Array.prototype.slice.call(slides.children);
      for (var i = 0; i < kids.length; i++) if (String(kids[i].getAttribute('data-media-id')) === String(mediaId)) { if (i !== currentIndex()) goTo(i, smooth); return; }
    }

    /* Ceny */
    function renderPrices() {
      var v = currentVariant();
      if (!v) return;
      var q = currentQty();
      var sale = v.compare > v.price;
      var pb = $('[data-price-block]', form);
      if (pb) {
        var now = $('[data-price-now]', pb), was = $('[data-price-was]', pb), save = $('[data-price-save]', pb);
        if (now) now.textContent = formatMoney(v.price);
        if (was) { was.textContent = sale ? formatMoney(v.compare) : ''; was.style.display = sale ? '' : 'none'; }
        if (save) {
          save.style.display = sale ? '' : 'none';
          if (sale) save.textContent = save.textContent.replace(/\d+\s?%/, Math.round((v.compare - v.price) * 100 / v.compare) + ' %');
        }
      }
      $$('[data-tier-save]', form).forEach(function (ts) {
        var tq = parseInt(ts.getAttribute('data-qty'), 10) || 1;
        ts.textContent = ts.textContent.replace(/[\d\s., ]+\s*(Kč|CZK|€|EUR)?\s*$/, ' ').trim() + ' ' + formatMoney((v.compare - v.price) * tq);
        ts.style.display = sale ? '' : 'none';
      });
      $$('[data-tier-price]', form).forEach(function (tp) {
        var tq = parseInt(tp.getAttribute('data-qty'), 10) || 1;
        var n = $('.price__now', tp), w = $('.price__was', tp);
        if (n) n.textContent = formatMoney(v.price * tq);
        if (w) w.textContent = sale ? formatMoney(v.compare * tq) : '';
      });
      if (atc) {
        atc.disabled = !v.available;
        if (atcLabel) atcLabel.textContent = v.available ? (atc.getAttribute('data-default-label') || BD.strings.addToCart) : BD.strings.soldOut;
      }
      var sticky = $('[data-sticky-atc] .price__now');
      if (sticky) sticky.textContent = formatMoney(v.price * q);
      var stWas = $('[data-sticky-atc] .price__was'), stSave = $('[data-sticky-atc] .price__save');
      if (stWas) { stWas.textContent = sale ? formatMoney(v.compare * q) : ''; stWas.style.display = sale ? '' : 'none'; }
      if (stSave) stSave.style.display = 'none';
      if (qtyInput) qtyInput.value = q;
    }

    /* Balíčky (vlastní náhrada Kachingu) */
    $$('[data-bundle-upsell]', form).forEach(function (c) {
      c.addEventListener('change', function () {
        $$('[data-bundle-upsell]', form).forEach(function (o) { o.checked = c.checked; });
      });
    });
    function syncFromSelects(e) {
      var r = checkedTier();
      var box = r && r.closest('[data-bundle-tier]');
      var first = box && $('[data-motif-select]', box);
      if (first) {
        idInput.value = first.value;
        var v = variantById(first.value);
        // při načtení stránky galerie neodjíždí (první je Vánoční kouzlo), posouvá se až při výběru motivu
        if (v && e) showMedia(v.media, true);
      }
      renderPrices();
    }
    $$('[data-motif-select]', form).forEach(function (sel) {
      sel.addEventListener('change', function () {
        var v = variantById(sel.value);
        var img = sel.parentNode.querySelector('.bdl__thumb img');
        if (v && v.img && img) { img.src = v.img; img.removeAttribute('srcset'); }
        if (v) showMedia(v.media, true);
        syncFromSelects();
      });
    });
    $$('[data-tier-radio]', form).forEach(function (r) { r.addEventListener('change', syncFromSelects); });
    $$('[data-bundle-tier]', form).forEach(function (tier) {
      var r = $('[data-tier-radio]', tier), box = $('.bdl__box', tier);
      if (!r || !box) return;
      box.addEventListener('click', function (e) {
        if (r.checked || e.target.closest('label, select, input')) return;
        r.checked = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    /* Přidání do košíku */
    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;
      e.preventDefault();
      var v = currentVariant();
      if (!v || !v.available) return;
      var q = currentQty();
      var items = [];
      var r = checkedTier();
      var tierBox = r ? r.closest('[data-bundle-tier]') : null;
      var selects = tierBox ? $$('[data-motif-select]', tierBox) : [];
      if (selects.length && selects.length === q) {
        var counts = {};
        selects.forEach(function (s) { counts[s.value] = (counts[s.value] || 0) + 1; });
        Object.keys(counts).forEach(function (id) { items.push({ id: parseInt(id, 10), quantity: counts[id] }); });
      } else {
        items.push({ id: v.id, quantity: q });
      }
      var upsell = $('[data-bundle-upsell]:checked', form);
      var bundle = $('[data-bundle]', form);
      if (bundle && bundle.dataset.giftVariant && q >= (parseInt(bundle.dataset.giftMin, 10) || 2)) {
        items.push({ id: parseInt(bundle.dataset.giftVariant, 10), quantity: 1, properties: { '_gift': '1' } });
      }
      if (atc) atc.classList.add('is-loading');
      if (atcLabel) atcLabel.textContent = BD.strings.adding;
      // fixy zůstávají zaškrtnuté; když už v košíku jsou, podruhé se nepřidají
      var cartReq = upsell ? fetch((BD.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return { items: [] }; }) : Promise.resolve(null);
      cartReq
        .then(function (c) {
          var uid = upsell && parseInt(upsell.value, 10);
          if (uid && !(c && (c.items || []).some(function (it) { return it.variant_id === uid; }))) items.push({ id: uid, quantity: 1 });
          return T.addItems(items);
        })
        .then(function () { return T.refreshCart(true); })
        .catch(function (err) { T.toast(err.message || BD.strings.error); })
        .then(function () { if (atc) atc.classList.remove('is-loading'); renderPrices(); });
    });

    /* Kdy to dorazí */
    var del = $('[data-delivery]', section);
    if (del) {
      var addBiz = function (d, n) { var x = new Date(d); var added = 0; while (added < n) { x.setDate(x.getDate() + 1); var day = x.getDay(); if (day !== 0 && day !== 6) added++; } return x; };
      var M = ['Led', 'Úno', 'Bře', 'Dub', 'Kvě', 'Čvn', 'Čvc', 'Srp', 'Zář', 'Říj', 'Lis', 'Pro'];
      var f = function (d) { return d.getDate() + '. ' + M[d.getMonth()]; };
      var today = new Date();
      var sMin = addBiz(today, +del.dataset.shipMin || 1), sMax = addBiz(today, +del.dataset.shipMax || 2);
      var dMin = addBiz(today, +del.dataset.delMin || 5), dMax = addBiz(today, +del.dataset.delMax || 12);
      var eo = $('[data-d-order]', del), es = $('[data-d-ship]', del), ed = $('[data-d-deliver]', del);
      if (eo) eo.textContent = f(today);
      if (es) es.textContent = (+del.dataset.shipMin === +del.dataset.shipMax) ? f(sMin) : f(sMin) + ' - ' + f(sMax);
      if (ed) ed.textContent = f(dMin) + ' - ' + f(dMax);
    }

    /* Plovoucí tlačítko */
    var sticky = $('[data-sticky-atc]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }).observe(atc);
      var sbtn = $('[data-sticky-atc-btn]', sticky);
      if (sbtn) sbtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else atc.click();
      });
    }

    syncFromSelects();
    updateNav(false);
  }

  window.BDInitProduct = initProduct;
  $$('[data-product-section]').forEach(initProduct);
})();
